/** @module Sourcing/MassAdoptSupplierItemsAsStyles */
define([
	"dojo/_base/declare",
	"csi/action/NewFromController",
	"./MassAdoptSupplierItemsAsStylesForm"
], function(declare, NewFromController, MassAdoptSupplierItemsAsStylesForm) {

	return declare(NewFromController, {
		/** the form needs to act like a New form for Style rather than a copy of SupplierItem */
		bUseNodeForForm: false,

		/**
		 *  Remove the necessary parameters to the request to avoid unwanted ChangeNode operations
		 */
		toWriterRequest: function() {
			var fd = this.getFormData();
			fd.getFieldValue("ParentSeason", true);
			fd.getFieldValue("Category1", true);
			fd.getFieldValue("Category2", true);

			return this.inherited(arguments);
		},

		/**
		 *  add special controller for adoption form
		 *  @param {Node} - node
		 *  @param {boolean} - bCheckOnly
		 */
		_getFormView: function(node, bCheckOnly) {
			var defView = this.inherited(arguments);
			if (defView) {
				defView.classController = MassAdoptSupplierItemsAsStylesForm;
			}

			return defView;
		}
	});
});